// 관리자 전용 게이팅 v2(07-11 보안 강화) — 종전엔 토큰이 이 파일(=공개 번들)에 평문으로 있었다.
// 이제 비밀키는 서버 .env(OWNER_KEY)에만 존재. 활성화: ?owner=<키> 1회 접속 → 키를 이 브라우저에 저장하고
// 모든 API 요청 헤더(X-Owner-Key)로 동봉(api.ts 인터셉터). 서버가 틀린 키는 404로 거절(존재 자체 은닉).
// 해제: ?owner=off. 기기마다(폰·PC) 링크 1회씩 필요.
const KEY = 'scanner_owner_key';

(() => {
  try {
    localStorage.removeItem('scanner_owner');   // 구버전 플래그 청소(토큰 노출 시절)
    const p = new URLSearchParams(window.location.search);
    if (!p.has('owner')) return;
    const v = p.get('owner');
    if (v === 'off' || !v) localStorage.removeItem(KEY);
    else {
      localStorage.setItem(KEY, v);
      // 활성화 직후 1회 서버 검증 — 틀린 키는 조용히 폐기(관리자 탭이 헛되이 뜨지 않게)
      fetch('/api/owner/check', { headers: { 'X-Owner-Key': v } })
        .then((r) => { if (!r.ok) localStorage.removeItem(KEY); })
        .catch(() => { /* 네트워크 문제면 유지 — 다음 API에서 판명 */ });
    }
    p.delete('owner');
    const qs = p.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
  } catch { /* noop */ }
})();

export function isOwner(): boolean {
  try {
    return !!localStorage.getItem(KEY);
  } catch {
    return false;
  }
}

export function ownerKey(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}
